import { render, staticRenderFns } from "./itemDetailHeader.vue?vue&type=template&id=081633f9&scoped=true"
import script from "./itemDetailHeader.vue?vue&type=script&lang=js"
export * from "./itemDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./itemDetailHeader.vue?vue&type=style&index=0&id=081633f9&prod&scoped=true&lang=css"
import style1 from "./itemDetailHeader.vue?vue&type=style&index=1&id=081633f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081633f9",
  null
  
)

export default component.exports